import i from './export-history.container';

export default i;
